import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path d="M12 9.5L7 14.5H17L12 9.5Z" xmlns="http://www.w3.org/2000/svg" />,
  "CaretUp"
);
